<template lang="html">
  <UIcon name="icon:loader" class="animation-count animate-ping duration-300" />
</template>

<script setup lang="ts"></script>
